import React from 'react';
import { v4 } from 'uuid';
import moment from "moment";
// This file is for helper functions with minimal dependencies.

export function convertISO_8601(str) {
  var date = moment(str);
  var dateComponent = date.utc().format('MM-DD-YYYY');
  var timeComponent = date.utc().format('HH:mm');
  return {
    dateComponent,
    timeComponent
  };
}
export function isContentEmpty(content) {
  let hasContent = false;
  content.forEach(entry => {
    if (entry !== '') {
      hasContent = true;
    }
  });
  return !hasContent;
}
export function apiURL() {
  if (window && window.location && window.location.href.startsWith("https://bittnerdevelopmentgroup.gitlab.io/interactive-builder/")) {
    return "https://bdg-interactive-builder.herokuapp.com";
  }
  return "http://localhost:5000";
}
export function apiFetch(urlSlug, obj) {
  return fetch(`${apiURL()}${urlSlug}`, Object.assign({
    mode: 'cors',
    credentials: 'include'
  }, obj));
}
export function apiFetchThen(urlSlug, obj, onSuccess, onError) {
  apiFetch(urlSlug, obj).then(r => r.json()).then(r => {
    if (r.message) {
      onError(r.message);
    } else {
      onSuccess(r);
    }
  }).catch(e => {
    onError(e.message);
  });
}
export function useFetch(urlSlug, obj, defaultValue, dependsUpon) {
  let [value, setValue] = React.useState(defaultValue);
  let [error, setError] = React.useState(undefined);
  React.useEffect(() => {
    apiFetch(urlSlug, obj).then(r => r.json()).then(r => {
      if (r.message) {
        setError(r.message);
      } else {
        setValue(r);
      }
    }).catch(e => {
      setError(e.message);
    });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlSlug].concat(dependsUpon || []));
  return [value, error, setValue, setError];
}
export function uniqueId(obj) {
  try {
    if (!obj._ibuid) {
      obj._ibuid = v4();
    }
    return obj._ibuid;
  } catch (e) {}
  return null;
}
export function useForceUpdate() {
  const [, setValue] = React.useState(0);
  return () => setValue(value => value + 1);
}

// Converts rich text to a simple string.
export function getRawText(node) {
  if (typeof node === "undefined") {
    return "";
  }
  if (node.hasOwnProperty("text")) return node.text;
  if (node.map === undefined && (typeof node === "string" || node.children === undefined)) return node;
  let str = "";
  for (const child of node.map ? node : node.children) {
    str += getRawText(child);
  }
  return str;
}

// Maps 0, 1, 2... to A, B, C...
export function numberToLetter(num) {
  return String.fromCharCode(65 + num);
}
export function isValidURL(url, optional) {
  if (optional && (url === null || url === void 0 ? void 0 : url.length) === 0) return true;
  try {
    new URL(url, 'https://localhost');
    return true;
  } catch (e) {
    return false;
  }
}
function iterateChildren(children, hierarchy, depth, path, func, tagName, tabPanel = false) {
  for (let i = 0; i < children.length; i++) {
    path.push(tagName ? `${tagName},${depth},${i}` : `${depth},${i}`);
    func(tabPanel ? children[i].contents : children[i], hierarchy, depth + 1, path);
    path.pop();
  }
}

// TODO Notes: 
// -Refactor containter components to use the same name for contents/items
// -Put container tagnames in a container and search instead of if elses
export function getChildComponents(parent, hierarchy, depth, path) {
  if (Array.isArray(parent)) {
    iterateChildren(parent, hierarchy, depth, path, getChildComponents);
  } else if (parent.tagName === "TaskTabPanel") {
    iterateChildren(parent.props.contents, hierarchy, depth, path, getChildComponents, parent.tagName, true);
  } else if (parent.tagName === "TaskCarousel") {
    iterateChildren(parent.props.items, hierarchy, depth, path, getChildComponents, parent.tagName);
  } else if (parent.tagName === "DesignRow") {
    iterateChildren(parent.children, hierarchy, depth, path, getChildComponents, parent.tagName);
  } else {
    if (path.length === 0) {
      hierarchy[parent.tagName] = parent;
    } else {
      hierarchy[path.join('|')] = parent;
    }
  }
}
export function getAllImages(parent, hierarchy, depth, path) {
  if (Array.isArray(parent)) {
    iterateChildren(parent, hierarchy, depth, path, getAllImages);
  } else if (parent.tagName === "TaskTabPanel") {
    iterateChildren(parent.props.contents, hierarchy, depth, path, getAllImages, true);
  } else if (parent.tagName === "TaskCarousel") {
    iterateChildren(parent.props.items, hierarchy, depth, path, getAllImages);
  } else if (parent.tagName === "Figure") {
    hierarchy[path.join('|')] = parent;
  }
}
export function buildHierarchy(parent, func) {
  let hierarchy = {};
  func(parent, hierarchy, 0, []);
  return hierarchy;
}

// Follows a path (a path is an array of indices) to its terminal child.
export function pathReduce(parent, path) {
  if (parent === undefined) {
    throw new Error(`pathReduce: parent is undefined (path: ${path.join(".")})`);
  }
  return path.reduce((item, key) => {
    if (item === undefined) {
      throw new Error(`pathReduce item[${key}]: item is undefined (path: ${path.join(".")})`);
    }
    return item[key];
  }, parent);
}

// Assigns an item given a path.
export function pathAssign(parent, path, assign) {
  let item = pathReduce(parent, path.slice(0, -1));
  item[path[path.length - 1]] = assign;
}

// Summarize the structure of an object or array. Mostly unused.
export function summarizeItem(item, depthLimit, charLimit) {
  let summary = "";
  let summarize = (obj, depth) => {
    if (depthLimit !== undefined && depth >= depthLimit || obj === undefined) return `${obj}`;
    let summary = "";
    for (const k of Object.keys(obj)) {
      if (!["tagName", "type"].includes(k) && obj.hasOwnProperty(k)) {
        //summary +=  + ", "
        summary += `${k}: ${typeof obj[k] === "object" ? summarize(obj[k], depth + 1) : obj[k]}, `;
      }
    }
    summary = summary.substr(0, summary.length - 2);
    if (summary.length > 0) {
      summary = obj.map ? `[${summary}]` : `{${summary}}`;
    }
    return summary;
  };
  //console.log("item: ", item)
  if ((item === null || item === void 0 ? void 0 : item.type) !== "Content") {
    summary += summarize(item.props, 0);
    summary += summarize(item.children, 0);
  } else {
    summary += summarize(item, 0);
  }
  if (charLimit !== undefined && summary.length > charLimit) {
    summary = summary.substr(0, charLimit - 1) + "…";
    let last1 = summary.lastIndexOf("[");
    let last2 = summary.lastIndexOf("{");
    if (last1 !== -1 && last2 !== -1) {
      if (last1 > last2) {
        summary += "]";
      } else {
        summary += "}";
      }
    } else if (last1 !== -1) {
      summary += "]";
    } else if (last2 !== -1) {
      summary += "}";
    }
  }
  return summary;
}